import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const AsthmaPage = () => {
  const treatmentData = {
    title: "Asthma",
    description: "Asthma is a chronic respiratory condition that affects breathing and can significantly impact daily life. Our natural herbal approach focuses on reducing inflammation, strengthening respiratory function, and preventing asthma attacks through gentle, effective treatments.",
    causes: [
      "Genetic factors",
      "Environmental triggers",
      "Respiratory infections",
      "Allergies",
      "Air pollution"
    ],
    symptoms: [
      "Wheezing and shortness of breath",
      "Chest tightness",
      "Coughing, especially at night",
      "Difficulty breathing during physical activity",
      "Sleep disturbances due to breathing problems"
    ],
    approach: "Our holistic treatment combines traditional herbs known for their respiratory benefits, lifestyle modifications, and breathing techniques to help manage asthma symptoms naturally. We focus on strengthening lung function and reducing sensitivity to triggers.",
    benefits: [
      "Reduces frequency and severity of attacks",
      "Improves lung function",
      "Minimizes reliance on inhalers",
      "Addresses root causes naturally"
    ],
    lifestyleRecommendations: [
      "Identify and avoid triggers",
      "Practice breathing exercises",
      "Maintain a clean, dust-free environment",
      "Stay physically active within safe limits"
    ],
    faqs: [
      {
        question: "Can herbal treatment replace my asthma medication?",
        answer: "While our treatment can help reduce symptoms, always consult your doctor before making changes to prescribed medications."
      },
      {
        question: "How long until I see improvement?",
        answer: "Many patients notice reduced symptoms within 2-4 weeks, with continued improvement over time."
      },
      {
        question: "Is this treatment safe for children?",
        answer: "Yes, our gentle herbal approach is suitable for all ages, including children."
      }
    ]
  };

  return <TreatmentPageTemplate {...treatmentData} />;
};

export default AsthmaPage; 